import { apiFetcher } from "./apiFetcher";

export const categoriesService = {
    getAllCategories
};

function getAllCategories() {
  return apiFetcher(`/categories/tree?active=1`, { method: "GET" });
}